import { render, staticRenderFns } from "./ShortVideoCard.vue?vue&type=template&id=5047b092&scoped=true"
import script from "./ShortVideoCard.vue?vue&type=script&lang=js"
export * from "./ShortVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ShortVideoCard.vue?vue&type=style&index=0&id=5047b092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5047b092",
  null
  
)

export default component.exports